import { faTrash, faUserGraduate } from '@fortawesome/free-solid-svg-icons'
import { Drawer } from 'antd'
import React, { useEffect, useState } from 'react'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { getSchools } from '../../reducers/SchoolsReducer'
import { getUser } from '../../reducers/UserReducer'
import { getSchoolStudents } from '../../utils/api/school'
import { addSupervisorStudents, deleteSupervisorStudents, getSupervisorStudents } from '../../utils/api/user'
import StudentInfo from '../shared/StudentInfo'
import UserStudentTable, { DATA_TYPE_SELECT, DATA_TYPE_STRING } from './UserStudentTable'

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    getUser: getUser(state.getUser),
    getSchools: getSchools(state.getSchools)
  }
}

const UserSupervisedStudents = ({ user, getUser, getSchools, schoolId, t, onClose }) => {
  const [userSupervisedStudents, setUserSupervisedStudents] = useState([])
  const [schoolStudents, setSchoolStudents] = useState([])
  const [selectedStudentInfo, setSelectedStudentInfo] = useState(null)
  const [currentSchool, setCurrentSchool] = useState(null)

  useEffect(() => {
    if (user === null) {
      setUserSupervisedStudents([])
    }

    if (user !== null) {
      getSupervisorStudents(user, getUser)
        .then(data => {
          setUserSupervisedStudents(data)
        })
    }
  }, [user, getUser])

  useEffect(() => {
    const school = selectedSchool(schoolId, getSchools)
      ? selectedSchool(schoolId, getSchools)
      : undefined

    if (school) {
      setCurrentSchool(school)

      getSchoolStudents(school, getUser)
        .then(data => {
          setSchoolStudents(data)
        })
    }
  }, [getSchools, getUser])

  const handleAddSection = student => {
    const newStudent = schoolStudents.filter(s => s.id === student.newId)[0]

    const newUserSupervisedStudents = userSupervisedStudents.concat(newStudent)

    const body = { student: student.newId }

    addSupervisorStudents(user, body, getUser).then((json) => {
      if (json?.data !== null) {
        setUserSupervisedStudents(newUserSupervisedStudents)
      }
    })
  }

  const handleEditSection = student => {
    const editedStudent = schoolStudents.filter(s => s.id === student.newId)[0]

    const newUserSupervisedStudents = userSupervisedStudents.map(s => {
      if (s.id === student.prevId) return editedStudent
      return s
    })

    setUserSupervisedStudents(newUserSupervisedStudents)
    deleteSupervisorStudents(user, student.prevId, getUser)

    const body = { student: student.newId }

    addSupervisorStudents(user, body, getUser)
  }

  const handleDeleteStudent = student => {
    const newUserSupervisedStudents = userSupervisedStudents.filter(s => s.id !== student.id)

    setUserSupervisedStudents(newUserSupervisedStudents)
    deleteSupervisorStudents(user, student.id, getUser)
  }

  const searchWithFilter = value => {
    getSupervisorStudents(user, getUser, value)
      .then(data => {
        setUserSupervisedStudents(data)
      })
  }

  const selectedSchool = (schoolId, getSchools) => {
    if (schoolId) {
      // also check cache
      if (this._previouslySelectedSchool && this._previouslySelectedSchool.id === schoolId) {
        return this._previouslySelectedSchool
      }
      const school = getSchools.find(item => item.id === schoolId)
      this._previouslySelectedSchool = school
    }
    return getSchools[0]
  }

  const render = () => {
    const students = schoolStudents

    const COLUMNS = [
      {
        type: DATA_TYPE_SELECT,
        name: 'Student',
        options: students
      },
      {
        type: DATA_TYPE_STRING,
        name: 'Section'
      }
    ]

    const additionalActions = [
      {
        icon: faUserGraduate,
        type: 'primary',
        title: t('Student sheet'),
        handleOnClick: s => setSelectedStudentInfo(s)
      },
      {
        icon: faTrash,
        type: 'danger',
        title: 'Delete',
        titlePopconfirm: t('Delete this student?'),
        handleOnClick: data => handleDeleteStudent(data)
      }
    ]

    return (
      <Drawer
        title={user !== null ? t('Student supervised by') + ' ' + user.lastname + ' ' + user.firstname : '?'}
        width='640px'
        onClose={onClose}
        visible={user !== null}
      >
        <UserStudentTable
          onDataAdd={handleAddSection}
          onDataEdit={handleEditSection}
          data={userSupervisedStudents}
          columns={COLUMNS}
          additionalActions={additionalActions}
          searchWithFilter={searchWithFilter}
          school={currentSchool}
        />
        <StudentInfo
          student={selectedStudentInfo}
          onClose={() => setSelectedStudentInfo(null)}
        />
      </Drawer>
    )
  }

  return (
    render()
  )
}

export default connect(mapStateToProps)(UserSupervisedStudents)
